import React from 'react';
import PropTypes from 'prop-types';
import ItemEditContainer from './item/ItemEditContainer';

const Item = ({ name, page, query }) => {
  return (
    <ItemEditContainer
      itemName={name}
      query={query}
      isProcess={page.page.ValidTypes && page.page.ValidTypes[0] === 'process'}
      options={page.page.Options}
    />
  );
};

Item.defaultProps = {
  query: {},
};

Item.propTypes = {
  name: PropTypes.string.isRequired,
  page: PropTypes.object.isRequired,
  query: PropTypes.object,
};

export default Item;
